import React from "react";
import { imageBasePath } from "../../Utils/config";

const TestimonialCard = ({ testimonial, index, leftIndxes }) => {
  const marginTop = !!leftIndxes?.includes(index) ? "mt-[35px]" : "mt-[50px]";
  return (
    <>
      <div className="flex flex-col justify-center items-center py-6 sm:py-10">
        <img
          src={imageBasePath + testimonial?.profileImage}
          alt={testimonial?.name + "image"}
        />
        <p className="font-font-Titillium font-bold text-[#262626] text-[22px] leading-[33px] tracking-[0.01em] text-center uppercase">
          {testimonial?.name}
        </p>
        <p className="font-font-Titillium font-semibold text-[16px] text-[#8C8C8C] leading-[21px] tracking-[0.0156em] text-center capitalize">
          {testimonial?.area}
        </p>
        <div
          className={
            !!leftIndxes?.includes(index)
              ? "before:bg-imageLeft before:content-[' '] before:w-[73px] before:h-[58px] before:block before:absolute"
              : "before:bg-imageRight before:content-[' '] before:w-[73px] before:h-[58px] before:block before:absolute before:right-[1%] sm:before:right-[3%] md:before:right-[5%] lg:before:right-[8%]"
          }
        >
          <p
            className={
              "font-font-Titillium font-normal text-[16px] text-[#262626] leading-[24px] text-center ml-[20px] " +
              marginTop
            }
          >
            {testimonial?.description}
          </p>
        </div>
      </div>
    </>
  );
};

export default TestimonialCard;
